import dayjs from 'dayjs';

import type { IListItem } from './interface.js';

import { getDayList } from '@/utils/dayjs.js';
import type { Presence, Profile, Client } from '@/store.js';

// @ts-ignore type
import detailData from '@/data/detail.json';

export function getDataService({ id }: { id: string }) {
  const res = detailData.find((i) => i.id === id);
  return res;
}

export type IPlanDetail = (typeof detailData)[0];
export async function getActList() {
  const res = await detailData;
  return res;
}

async function getDateList({
  dateArray,
  planId,
  client,
}: {
  dateArray: string[];
  planId: string;
  client: Client<Presence, Profile>;
}) {
  const result: IListItem[] = [];
  let dateIdx = 0;
  for (const date of dateArray) {
    const keyBase = `${date}-${dateIdx}`;

    if (date !== '总览') {
      result.push({
        type: 'DayTitle',
        key: keyBase,
        props: {
          date,
          id: '总览',
        },
      });
    }

    // STEP: 获取时间
    let eventsList = await client.events.findAll({
      index: {
        where: 'planId_date',
        match: { date, planId: planId === '2' ? '' : planId },
      },
    }).resolved;

    // STEP: 排序
    eventsList = eventsList.sort(
      (a, b) =>
        (a.get('orderIdx') || a.get('createdAt') || 0) -
        (b.get('orderIdx') || b.get('createdAt') || 0)
    );

    for (const event of eventsList) {
      const {
        type,
        airplane,
        id,
        createdAt,
        orderIdx: orderIdxOrigin,
      } = event.getAll();
      const orderIdx = orderIdxOrigin || createdAt;

      if (type === 'airplane') {
        const dataRaw = airplane?.getAll();
        if (dataRaw) {
          const { no, ...data } = dataRaw;
          if (no && no !== null) {
            // STEP: 上一条是否是航班
            let lastItem = result[result.length - 1];
            if (lastItem && lastItem?.type === 'DayTitle') {
              lastItem = result[result.length - 3];
            }

            if (lastItem?.type === 'AirPlane') {
              result.push({
                type: 'Transfer',
                props: { lastNo: lastItem.props.no, no, date, id },
                key: `${keyBase}-Transfer-${id}`,
              });
            }

            result.push({
              type: 'AirPlane',
              props: { date, ...data, no, planId, id },
              key: `${keyBase}-AirPlane-${id}`,
              orderIdx: orderIdx,
            });
          }
        }
      } else if (type === 'route') {
        result.push({
          type: 'Route',
          props: {
            id,
            date,
          },
          key: `${keyBase}-Route-${id}`,
          orderIdx: orderIdx,
        });
      } else {
        // NOTICE: 默认都是自定义
        result.push({
          type: 'Custom',
          props: {
            id,
          },
          key: `${keyBase}-Custom-${id}`,
          orderIdx: orderIdx,
        });
      }
    }

    // STEP: 插入活动追加
    result.push({
      type: 'Add',
      key: `${keyBase}-Add-${dateIdx}`,
      props: {
        planId,
        date,
        id: `${keyBase}-Add-${dateIdx}`,
      },
    });

    // STEP: 插入分割
    result.push({
      type: 'Divider',
      key: `${keyBase}-Divider-${dateIdx}`,
      props: {
        id: `${keyBase}-Divider-${dateIdx}`,
      },
    });

    dateIdx += 1;
  }

  return result;
}

export async function getListService({
  id: planId,
  client,
}: {
  id: string;
  client: Client<Presence, Profile>;
}) {
  const data = await getDataService({ id: planId });
  if (!data) return undefined;

  const startTime = dayjs(data.startTime).startOf('day');
  const endTime = dayjs(data.endTime).endOf('day');

  // STEP: 生成日期数组
  const dateArray = getDayList({ startTime, endTime });

  return await getDateList({ dateArray, planId, client });
}

export async function getOverviewService({
  id: planId,
  client,
}: {
  id: string;
  client: Client<Presence, Profile>;
}) {
  const data = await getDataService({ id: planId });
  if (!data) return undefined;

  // STEP: 生成日期数组
  const dateArray = ['总览'];

  return await getDateList({ dateArray, planId, client });
}
